import { supabase } from '../clients/supabaseClient';

export type UserRole = {
    key: string;
    label: string;
};

export type CreateUserPayload = {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    cellphone: string;
    role: string;
    car_model?: string;
    number_plate?: string;
    store_id?: string | null;
};

type CreateUserResponse = {
    user_id?: string;
    error?: string;
};

export async function fetchUserRolesFromDb(): Promise<UserRole[]> {
    const { data, error } = await supabase
        .from('user_roles')
        .select('key, label')
        .eq('is_active', true)
        .order('sort_order', { ascending: true });

    if (error) throw error;
    return data ?? [];
}

export async function createUserInDb(payload: CreateUserPayload): Promise<void> {
    // User creation runs through an Edge Function using the admin API
    // (auth.admin.createUser) rather than client-side auth.signUp(),
    // because signUp() from the browser replaces the *caller's* session
    // with the newly created user's session.
    const { data, error } = await supabase.functions.invoke<CreateUserResponse>(
        'create-user',
        { body: payload },
    );

    if (error) {
        let message = error.message;
        const context = (error as { context?: Response }).context;
        if (context) {
            try {
                const body = await context.json();
                if (body?.error) message = body.error;
            } catch {
                // no JSON body on the error response — fall back to error.message
            }
        }
        throw new Error(message);
    }

    if (data?.error) {
        throw new Error(data.error);
    }
}